import React from "react";
import "./Navbar.scss";

/*   Images */
import logo from "../../Assets/Images/logo.png";

/*   Icons */
import discord from "../../Assets/Icons/discord.svg";
import instagram from "../../Assets/Icons/instagram.svg";
import twitter from "../../Assets/Icons/twitter.svg";

const Navbar = ({ homeNav }) => {
  return (
    <div id="navbar">

      <header className="navbarContent">
        <a href="/">
          <img className="navlogo" src={logo} alt="logo" />
        </a>
        <nav>
          <ul className="navbar-nav me-auto">
            <li className="nav-item ms-md-3">
              <a
                className="nav-link"
                activeClassName={"current"}
                href="/#features"
              >
                Features
              </a>
            </li>
            <li className="nav-item ms-md-3">
              <a
                className="nav-link"
                activeClassName={"current"}
                href="/#about"
              >
                About
              </a>
            </li>
            <li className="nav-item ms-md-3">
              <a
                className="nav-link"
                activeClassName={"current"}
                href="/#join"
              >
                Join
              </a>
            </li>
            <li className="nav-item ms-md-3">
              <a className="nav-link" activeClassName={"current"} href="/#faq">
                Testimonials
              </a>
            </li>
            {/* <li className="nav-item ms-md-3">
            <a className="nav-link" activeClassName={"current"} href="/#faq">
              FAQ
            </a>
          </li> */}
          </ul>
          <ul className="socialContainer">
            <li className="nav-item">
              <a href="https://whop.com/frugal-szn-1" target="_blank">
                <img className="socialLogo" src={discord} alt="logo" />
              </a>
            </li>
            <li className="nav-item">
              <a href="https://twitter.com/Frugalszn" target="_blank">
                <img className="socialLogo" src={twitter} alt="logo" />
              </a>
            </li>
            <li className="nav-item">
              <a href="https://www.instagram.com/frugalseason/" target="_blank">
                <img className="socialLogo" src={instagram} alt="logo" />
              </a>
            </li>
          </ul>
        </nav>
        <div className="btnContainer">
          <a href="#join">
            <div className="btn joinNowButton text-nowrap">Join Now</div>
          </a>
          <a href="https://whop.com/hub?login=true">
            <div className="btn dashboardButton text-nowrap">Dashboard</div>
          </a>
        </div>
      </header>

    </div>
  );
};

export default Navbar;
